// ## function declaration
function scrollEventThrottle(fn) {
	let last_known_scroll_position = 0;
	let ticking = false;
	window.addEventListener("scroll", function () {
		let previous_known_scroll_position = last_known_scroll_position;
		last_known_scroll_position = window.scrollY;
		if (!ticking) {
			window.requestAnimationFrame(function () {
				fn(last_known_scroll_position, previous_known_scroll_position);
				ticking = false;
			});
			ticking = true;
		}
	});

	window.addEventListener("scrollend", function () {
		jQuery(".media__tiktoks__container").removeClass("pe-none");
	});
}

// ## function invocation
scrollEventThrottle((scrollPos, previousScrollPos) => {
	jQuery(".media__tiktoks__container").addClass("pe-none");
});
